import React from "react";
import QrScanner from "./QrScanner";

function App() {
  return (
    <div className="App">
      <QrScanner />
    </div>
  );
}

export default App;
